module.exports = __webpack_public_path__ + "media/src/images/page02_sub_001_zu0302-e4dd7f5b384ecc96e3dab6d44d3610f9.png";